import axios from '../../../axios';
import { JobInformationReqTemplate } from '../types/JobInformationReqTemplate';

const urls = 'corphiringservice/api/job-evaluation';
const informationUrls = 'corphiringservice/api/job-information-req-template';
const infoTmplateUrl = 'corphiringservice/api/information-category';

export const getEvaluationTemplatesByJob = (JobId: string) =>
  axios.get(`${urls}/fetch?jobId=${JobId}`);

export const mapJobWithEvaluation = (jobEvaluationRequest: any) =>
  axios.post(`${urls}/map`, jobEvaluationRequest);

export const mapJobWithInformationReqTemplate = (infoCateogryRequest: JobInformationReqTemplate) =>
  axios.post(`${informationUrls}/map`, infoCateogryRequest);

export const getInformationReqTemplatesByJob = (JobId: string) =>
  axios.get(`${informationUrls}/fetch?jobId=${JobId}`);

export const mapJobWithInformationTemplate = (jobInfoRequest: any) =>
  axios.post(`${infoTmplateUrl}/map`, jobInfoRequest);
